<template>
    <ul class="doctor-list staff">
        <li class="doctor-list__item">
            <div class="doctor-list--img">
                <img src="/resource/img/staff-img01.jpg" alt="이미지">
            </div>
            <div class="doctor-list--con">
                <div class="doctor-list--text">
                    <h5 class="title03">Director of EGHMS</h5>
                    <h3 class="doctor-list--name">Kyung Ho Kang</h3>
                    <p class="doctor-list--department">Surgery, Cancer Center, Thyroid Center, Ewha Global Healthcare Medical System(EGHMS)</p>

                    <h4 class="doctor-list--clinic">Specialty</h4>
                    <p class="doctor-list--desc">Thyroid and parathyroid diseases, Robot Da Vinci Surgery</p>
                </div>
            </div>
        </li>
        <li class="doctor-list__item">
            <div class="doctor-list--img">
                <img src="/resource/img/staff-img02.jpg" alt="이미지">
            </div>
            <div class="doctor-list--con">
                <div class="doctor-list--text">
                    <h5 class="title03">Deputy Director of EGHMS</h5>
                    <h3 class="doctor-list--name">Seo Yon Yang</h3>
                    <p class="doctor-list--department">Rehabilitation Medicine, Joint-Spine Center, Well-aging Center, Stroke Center, Breast center</p>

                    <h4 class="doctor-list--clinic">Specialty</h4>
                    <p class="doctor-list--desc">Pain rehabilitation, Neurorehabilitation, Electrodiagnostic medicine</p>
                </div>
            </div>
        </li>
        <li class="doctor-list__item">
            <div class="doctor-list--img">
                <img src="/resource/img/staff-img03.jpg" alt="이미지">
            </div>
            <div class="doctor-list--con">
                <div class="doctor-list--text">
                    <h5 class="title03">Team Manager of EGHMS</h5>
                    <h3 class="doctor-list--name">Sang Hyun Kim</h3>
                    <p class="doctor-list--department">Ewha Global Healthcare Medical System(EGHMS)​</p>
                </div>
            </div>
        </li>
        <li class="doctor-list__item">
            <div class="doctor-list--img">
                <img src="/resource/img/staff-img04.jpg" alt="이미지">
            </div>
            <div class="doctor-list--con">
                <div class="doctor-list--text">
                    <h5 class="title03">Registered Nurse</h5>
                    <h3 class="doctor-list--name">Minji Yoon</h3>
                    <h4 class="doctor-list--clinic">Contact</h4>
                    <p class="doctor-list--desc">
                        +82-2-2650-5890 <br>
                        ewhaint@gmail.com
                    </p>
                </div>
            </div>
        </li>
        <li class="doctor-list__item">
            <div class="doctor-list--img">
                <img src="/resource/img/staff-img05.jpg" alt="이미지">
            </div>
            <div class="doctor-list--con">
                <div class="doctor-list--text">
                    <h5 class="title03">Chinese Coordinator</h5>
                    <h3 class="doctor-list--name">Zhang Hui Ting</h3>
                    <h4 class="doctor-list--clinic">Contact</h4>
                    <p class="doctor-list--desc">
                        +82-2-6986-5893 <br>
                        微信号：eumc123
                    </p>
                </div>
            </div>
        </li>
        <li class="doctor-list__item">
            <div class="doctor-list--img">
                <img src="/resource/img/staff-img06.jpg" alt="이미지">
            </div>
            <div class="doctor-list--con">
                <div class="doctor-list--text">
                    <h5 class="title03">Russian Coordinator</h5>
                    <h3 class="doctor-list--name">Yakhnenko Angelina</h3>
                    <h4 class="doctor-list--clinic">Contact</h4>
                    <p class="doctor-list--desc">
                        +82-2-6986-5892 <br>
                        ewha.rus@gmail.com
                    </p>
                </div>
            </div>
        </li>
        <li class="doctor-list__item">
            <div class="doctor-list--img">
                <img src="/resource/img/staff-img07.jpg" alt="이미지">
            </div>
            <div class="doctor-list--con">
                <div class="doctor-list--text">
                    <h5 class="title03">English Coordinator</h5>
                    <h3 class="doctor-list--name">Hanna Je</h3>
                    <h4 class="doctor-list--clinic">Contact</h4>
                    <p class="doctor-list--desc">
                        +82-2-6986-3100 <br>
                        eumcint@gmail.com
                    </p>
                </div>
            </div>
        </li>
        <li class="doctor-list__item">
            <div class="doctor-list--img">
                <img src="/resource/img/staff-img08.jpg" alt="이미지">
            </div>
            <div class="doctor-list--con">
                <div class="doctor-list--text">
                    <h5 class="title03">Mongolian Coordinator​</h5>
                    <h3 class="doctor-list--name">Logshir Davaasuren (Davaa)</h3>
                    <h4 class="doctor-list--clinic">Contact</h4>
                    <p class="doctor-list--desc">
                        +82-2-6986-5894 <br>
                        ewha.mongol@gmail.com​​
                    </p>
                </div>
            </div>
        </li>
        <li class="doctor-list__item">
            <div class="doctor-list--img">
                <img src="/resource/img/staff-img09.jpg" alt="이미지">
            </div>
            <div class="doctor-list--con">
                <div class="doctor-list--text">
                    <h5 class="title03">English Coordinator</h5>
                    <h3 class="doctor-list--name">Songyi Baek</h3>
                    <h4 class="doctor-list--clinic">Contact</h4>
                    <p class="doctor-list--desc">
                        +82-2-6986-5891 <br>
                        eumcint@gmail.com
                    </p>
                </div>
            </div>
        </li>
        <li class="doctor-list__item">
            <div class="doctor-list--img">
                <img src="/resource/img/staff-img10.jpg" alt="이미지">
            </div>
            <div class="doctor-list--con">
                <div class="doctor-list--text">
                    <h5 class="title03">Arabic Coordinator​</h5>
                    <h3 class="doctor-list--name">Yeseul Park (Widad)</h3>
                    <h4 class="doctor-list--clinic">Contact</h4>
                    <p class="doctor-list--desc">
                        +82-2-6986-5895 <br>
                        ewha.arab@gmail.com
                    </p>
                </div>
            </div>
        </li>
    </ul>
</template>

<script>
    export default {
        components: {
        },
        mounted() {
        },
    }
</script>